import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CART_KEY = "bergamote_cart";

export const getProducts = () => axios.get(`${API}/shop/products`).then((r) => r.data);
export const addProduct = (p) => axios.post(`${API}/shop/products`, p).then((r) => r.data);
export const deleteProduct = (id) => axios.delete(`${API}/shop/products/${id}`).then((r) => r.data);
export const checkout = (payload) => axios.post(`${API}/shop/checkout`, payload).then((r) => r.data);
export const getOrderStatus = (sessionId) => axios.get(`${API}/shop/orders/${sessionId}`).then((r) => r.data);

export const getCart = () => {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || [];
  } catch {
    return [];
  }
};

export const saveCart = (items) => {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("cart-updated"));
};

export const addToCart = (product, sizeLabel, qty = 1) => {
  const cart = getCart();
  const key = `${product.id}:${sizeLabel}`;
  const existing = cart.find((i) => i.key === key);
  if (existing) {
    existing.quantity = Math.min(10, existing.quantity + qty);
  } else {
    const size = product.sizes.find((s) => s.label === sizeLabel);
    cart.push({
      key,
      product_id: product.id,
      name_fr: product.name_fr,
      name_en: product.name_en,
      image: product.image,
      size_label: sizeLabel,
      unit_price: size.price,
      quantity: Math.min(10, qty),
    });
  }
  saveCart(cart);
};

export const cartCount = () => getCart().reduce((n, i) => n + i.quantity, 0);
export const cartTotal = () => getCart().reduce((n, i) => n + i.unit_price * i.quantity, 0);
